<template>
  <div class="cloud-holder-wrapper" :class="{'pad-bot-15': opened}">
    <div class="header-wrapper">
      <div class="add-file-wrapper">
        <button
          class="sub-ctass image-upload-btn add-file-button pointer blc-color pop-500"
          @click="openFileUploader()"
        >
          + pridať
        </button>
        <button
          v-if="files.length"
          class="cloud-zip-button pointer"
          type="button"
          :disabled="zipLoading"
          @click="downloadCloudArchive"
        >
          {{ zipLoading ? "Balím…" : "Stiahnuť ZIP" }}
        </button>
      </div>
      <div class="cloudLabel">
        <div id="Client-name">{{ cloud.type_label }}<br><span class="_900 big">{{ !cloud.label?.includes("nomail.bankari.sk") ? cloud.label : "" }}</span></div>
        <img
          src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg"
          class="activate-button nav-link-icon filter-primary"
          :class="{'rotate': opened}"
          @click="opened = !opened"
          alt=""
        />
      </div>
    </div>
    <v-expand-transition class="summary-items-transition">
      <div class="filesList" v-if="opened && files.length === 0">
        Tento cloud je zatiaľ prázdny,
      </div>
      <div class="filesList" v-else-if="opened && files.length !== 0">
        <div
          data-v-09f30b34=""
          class="discount-item field-names"
          v-for="(cloudFile, index) in files"
          :key="index"
          v-if="cloudFile.type?.code !== 'vygenerovana_ziadost'"
        >
          <v-progress-circular
            v-if="cloudFile.loading"
            class="loading-spinner small"
            indeterminate
          ></v-progress-circular>
          <div
            v-else-if="type && cloudFile?.type?.id !== type"
            class="text-cta pointer"
            @click="assignFileType(cloudFile, index)"
          >
            Vybrať
          </div>
          <div class="text-cta pointer" v-else></div>
          <div class="fileName">{{ cloudFile.name }}</div>
          <div class="fileTimestamp">{{ getDay(cloudFile.created) }}.{{ getMonth(cloudFile.created) }}.{{ getYears(cloudFile.created) }}</div>
<!--            v-if="isFilePdf(cloudFile.name)"-->
          <a
            :href="cloudFile.file"
            target="_blank"
            class="text-cta pointer"
            style="text-decoration: none"
          >
            Stiahnuť
          </a>
<!--          <div-->
<!--            v-else-->
<!--            @click="download(cloudFile)"-->
<!--            class="text-cta pointer"-->
<!--            style="text-decoration: none"-->
<!--          >-->
<!--            STIAHNUŤ-->
<!--          </div>-->
<!--          TODO: pridať v-if="!cloudFile.type"-->
          <div
            class="text-cta pointer"
            @click="deleteCloudFile(cloudFile, index)"
          >
            Vymazať
          </div>
        </div>
        <div
          data-v-09f30b34=""
          class="discount-item field-names"
          v-for="(_, key) in loadingFiles"
          :key="key+999"
        >
          <v-progress-circular
            class="loading-spinner small"
            indeterminate
          ></v-progress-circular>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>
<script>
import {
  getCloudFilesByCloudId, getFile,
  postFileToCloud,
  removeCloudFileByID
} from "@/services/brokerService";
import cloudsHelpers from "@/mixins/cloudsHelpers";

export default {
  name: "DocumentCloudItem",
  mixins: [cloudsHelpers],
  props: {
    type: [Number, null],
    cloud: Object,
    openOnLoad: Boolean,
    extra: Object,
    metaData: [Object, null],
  },
  async created() {
    if (this.cloud.files) {
      this.files = this.cloud.files;
      if (!this.type) this.pickAble = false;
    } else {
      this.files = (await getCloudFilesByCloudId(this.cloud.id)).cloud.cloud_files;
      this.pickAble = false;
    }
    this.opened = this.openOnLoad;
    const dirtyLabel = this.cloud.type_label.toLowerCase();
    this.cleanLabel = dirtyLabel.substring(0, 5) + "u" + dirtyLabel.substring(5, dirtyLabel.length);
  },
  watch: {
    async metaData(metaData) {
      if (!metaData || metaData.cloudId !== this.cloud.id) return;
      const file = new File([metaData.blob], metaData.fileName, {type: metaData.blob.type});
      if (this.extra?.applicationId && this.extra?.applicationDocumentType) {
        await this.uploadApplicationDocument(file);
        return;
      }
      await this.handleFiles([file]);
    }
  },
  methods: {
    async downloadCloudArchive() {
      this.zipLoading = true;
      try {
        const safeLabel = (this.cloud.type_label || "cloud")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^a-zA-Z0-9_-]+/g, "-")
          .replace(/^-+|-+$/g, "") || "cloud";
        await this.downloadFilesAsZip(this.files, safeLabel);
      } catch (error) {
        this.$store.commit("appState/setSuccessMessage", {
          text: "ZIP cloudu sa nepodarilo vytvoriť. Skúste to prosím znova.",
          type: "error",
        });
      } finally {
        this.zipLoading = false;
      }
    },
    // upravene cez GPT
    async download(fileObject) {
      try {
        const response = await getFile(fileObject.file);

        if (!response || !response.data) {
          console.error("❌ Súbor sa nepodarilo načítať:", fileObject);
          this.$store.commit("appState/setSuccessMessage", {
            text: "Nepodarilo sa načítať súbor. Skúste to prosím znova.",
            type: "error"
          });
          return;
        }

        const file = response.data;
        const url = URL.createObjectURL(
          new Blob([file], {
            type: this.getCloudFileTypeByExtension(fileObject.name)
          })
        );

        const a = document.createElement("a");
        a.href = url;
        a.download = fileObject.name;
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        console.error("⚠️ Chyba pri sťahovaní:", err);
        this.$store.commit("appState/setSuccessMessage", {
          text: "Pri sťahovaní súboru nastala chyba.",
          type: "error"
        });
      }
    },
    // urpavence cez GPT kvôi dalsim typom
    getCloudFileTypeByExtension(fileName) {
      const fileExtension = fileName.match(/\.[0-9a-z]+$/i)?.[0]?.toLowerCase();

      switch (fileExtension) {
        case ".pdf":
          return "application/pdf";
        case ".xlsx":
          return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        case ".png":
          return "image/png";
        case ".jpg":
        case ".jpeg":
          return "image/jpeg";
        case ".doc":
          return "application/msword";
        case ".docx":
          return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        case ".zip":
          return "application/zip";
        case ".asice":
          return "application/vnd.etsi.asic-e+zip"; // oficiálny MIME typ pre .asice
        default:
          return "application/octet-stream"; // fallback pre neznáme typy
      }
    },
    // pridane cez gpt kvoli dalsim typom files
    isFilePdf(fileName) {
      if (!fileName) return false; // žiadne meno, určite nie PDF

      const match = fileName.match(/\.[0-9a-z]+$/i);
      if (!match) return false; // ak nemá príponu, sťahuj

      const fileExtension = match[0].toLowerCase();

      // všetky typy, ktoré sa MAJÚ sťahovať (nie otvárať)
      const nonPdfTypes = [
        ".doc", ".docx", ".zip", ".xlsx", ".png", ".jpg", ".jpeg", ".asice"
      ];

      return fileExtension === ".pdf";
    },
    async assignFileType(file) {
      try {
        if (this.extra?.applicationId && this.extra?.applicationDocumentType) {
          const blob = (await getFile(file.file)).data;
          const copiedFile = new File([blob], file.name, {
            type: blob.type || this.getCloudFileTypeByExtension(file.name),
          });
          const uploaded = await this.uploadApplicationDocument(copiedFile);
          if (uploaded && !file.type) await removeCloudFileByID(file.id);
          return;
        }

        if (this.extra?.force) {
          await this.cleanOldTypes();
          this.files = this.$store.getters["mortgageDetailCloud/getCloudFilesByCloudId"](this.cloud.id);
        }
        await this.setFileType(file);
        if (this.type === 6) {
          const mortgage = this.$store.getters["mortgageDetailState/getMortgage"];
          const mortgageObject = {
            id: mortgage.id,
            object: {
              stage_old: mortgage.stage,
              stage: "kompletizacia_podkladov",
            },
          };
          await this.$store.dispatch("mortgageDetailState/patchMortgage", mortgageObject);
        }
      } catch (error) {
        this.$store.commit("appState/setSuccessMessage", {
          text: "Dokument sa nepodarilo priradiť. Skúste to prosím znova.",
          type: "error",
        });
      }
    },
    async cleanOldTypes() {
      const newFileType = (this.$store.getters["mortgageDetailCloud/getCloudFileTypeById"](this.type)).code;
      await this.$store.dispatch("mortgageDetailCloud/nullSpecificTypesForSpecificCloud", {
        cloudId: this.cloud.id,
        type: newFileType
      });
    },
    async setFileType(file) {
      const index = this.files.map(f => f.id).indexOf(file.id);
      const fileLoading = {...file, loading: true};
      this.files.splice(index, 1, fileLoading);
      const transformedFile = await this.$store.dispatch("mortgageDetailCloud/assignFileTypeToFile", {file, typeId: this.type});
      this.files.splice(index, 1, transformedFile);
    },
    openFileUploader() {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        extra: this.extra?.accept,
        type: this.cloud.id,
        payload: null,
        component: "DocumentCloudFileUpload",
        rules: ["single"],
      });
    },
    async uploadApplicationDocument(file) {
      this.loadingFiles = [file];
      try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("name", file.name);
        formData.append("document_type", this.extra.applicationDocumentType);
        await this.$store.dispatch("mortgageDetailState/replaceApplicationDocument", {
          applicationId: this.extra.applicationId,
          formData,
        });
        this.$store.commit("appState/setSuccessMessage", {
          text: this.extra.applicationDocumentType === "podpisana_ziadost"
            ? "Podpísaná žiadosť bola nahraná a stav sa aktualizoval."
            : "Žiadosť bola nahraná a stav sa aktualizoval.",
          type: "success",
        });
        // The file-upload modal has already closed. Close the parent cloud modal
        // after the authoritative server response so the row immediately redraws.
        this.$store.commit("popupManagerState/popItemFromPopupOrder");
        return true;
      } catch (error) {
        const serverMessage = error.response?.data?.file?.[0];
        this.$store.commit("appState/setSuccessMessage", {
          text: serverMessage || "Dokument sa nepodarilo nahrať. Skúste to prosím znova.",
          type: "error",
        });
        return false;
      } finally {
        this.loadingFiles = [];
      }
    },
    async deleteCloudFile(file, index) {
      this.files.splice(index, 1);
      try {
        this.$store.commit("appState/setSuccessMessage", {
          text: `Úspešne ste odstránili súbor z ${this.cleanLabel}`,
          type: "success"
        });
        await removeCloudFileByID(file.id);
        if (this.cloud.files && file.type) {
          this.$store.commit("mortgageDetailCloud/removeCloudFile", {cloudId: file.cloud, file: file});
        }
      } catch (e) {
        this.$store.commit("appState/setSuccessMessage", {
          text: `Pri odstraňovaní súboru z ${this.cleanLabel} sa niečo pokazilo`,
          type: "error"
        });
        this.files = (await getCloudFilesByCloudId(this.cloud.id)).cloud.cloud_files;
      }
    },
    getMonth(created) {
      const date = new Date(created);
      return date.getMonth() + 1;
    },
    getYears(created) {
      const date = new Date(created);
      return date.getFullYear();
    },
    getDay(created) {
      const date = new Date(created);
      return date.getDate();
    },
    async handleFiles(files) {
      if (files.length === 0) return;
      try {
        const newFiles = await this.prepareFiles(files);
        this.files = [...this.files, ...newFiles];
      } catch (error) {
        this.files = (await getCloudFilesByCloudId(this.cloud.id, "cloud_files.type")).cloud.cloud_files;
        const serverMessage = error.response?.data?.file?.[0];
        const message = error.response?.status === 413
          ? "Súbor je príliš veľký. Maximálna veľkosť je 25 MB."
          : (serverMessage || "Súbor sa nepodarilo nahrať. Skontrolujte jeho veľkosť a formát.");
        this.$store.commit("appState/setSuccessMessage", {text: message, type: "error"});
      } finally {
        this.loadingFiles = [];
      }
    },
    removeExtension(filename) {
      return filename.substring(0, filename.lastIndexOf('.')) || filename;
    },
    removeFile() {
      this.files = [];
    },
    async prepareFiles(files) {
      const newFiles = [];
      this.loadingFiles = files;
      for (const file of files) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("name", file.name);
        formData.append("cloud", this.cloud.id);
        newFiles.push(await postFileToCloud(formData));
      }
      if (this.cloud.files) {
        this.$store.commit("mortgageDetailCloud/registerNewFiles", newFiles);
      }
      this.$store.commit("appState/setSuccessMessage", {
        text: `Úspešne ste pridali ${files.length === 1 ? 'súbor' : 'súbory'} do ${this.cleanLabel}`,
        type: "success"
      });
      return newFiles;
    },
  },
  data: () => ({
    url: null,
    pickAble: false,
    opened: false,
    cleanLabel: null,
    files: [],
    loadingFiles: [],
    zipLoading: false,
  }),
};

</script>

<style lang="scss" scoped>
.cloud-holder-wrapper {
  margin-bottom: 12px;
  padding: 16px;
  border: 1px solid var(--app-border);
  border-radius: 14px;
  background: var(--app-surface);
  color: var(--app-text);
  box-shadow: var(--app-shadow);
}

.header-wrapper {
  display: grid;
  grid-template-columns: 132px minmax(0, 1fr);
  align-items: center;
  gap: 16px;
}

.add-file-button {
  display: inline-flex;
  width: 100%;
  min-height: 40px;
  padding: 8px 13px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--app-primary);
  border-radius: 10px;
  background: var(--app-primary-soft);
  color: var(--app-primary) !important;
  font-family: inherit;
  font-size: 11px;
  font-weight: 700 !important;
  cursor: pointer;
}

.add-file-wrapper {
  display: grid;
  gap: 7px;
}

.cloud-zip-button {
  min-height: 32px;
  padding: 6px 9px;
  border: 1px solid var(--app-border);
  border-radius: 9px;
  background: var(--app-surface-muted);
  color: var(--app-primary);
  font-family: inherit;
  font-size: 10px;
  font-weight: 700;
}

.cloud-zip-button:disabled {
  opacity: 0.6;
  cursor: wait;
}

.cloudLabel {
  min-width: 0;
  align-items: center;
  color: var(--app-text);
}

.filesList {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--app-border);
  color: var(--app-text-muted);
}

.discount-item.field-names {
  display: grid;
  grid-template-columns: 70px minmax(180px, 1fr) 92px 86px 76px;
  width: 100%;
  margin: 0 0 8px;
  padding: 10px 12px;
  align-items: center;
  gap: 10px;
  border: 1px solid var(--app-border);
  border-radius: 10px;
  background: var(--app-surface-muted);
  color: var(--app-text);
}

.discount-item.field-names .fileName {
  color: var(--app-text);
  font-weight: 500;
}

.discount-item.field-names .fileTimestamp {
  color: var(--app-text-muted);
  text-align: right;
}

.discount-item.field-names .text-cta {
  padding: 6px 7px !important;
  border-radius: 7px;
  color: var(--app-primary) !important;
  font-size: 9px;
  font-weight: 800;
  text-align: center;
}

.discount-item.field-names .text-cta:hover {
  background: var(--app-primary-soft);
}

@media screen and (max-width: 767px) {
  .header-wrapper {
    grid-template-columns: minmax(0, 1fr);
  }

  .discount-item.field-names {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }

  .discount-item.field-names .fileTimestamp {
    display: none;
  }

  .discount-item.field-names > .text-cta:first-child {
    display: none !important;
  }
}

</style>
